import { Suspense } from 'react';
import React from 'react';
import { LawPortalModule } from './LawPortalModule';

// Lazy loading ke liye uncomment karein:
// const LawPortalModule = React.lazy(() => import("./LawPortalModule"));

const LawPortalModuleProxy = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <LawPortalModule />
  </Suspense>
);

export default LawPortalModuleProxy;